<mat-toolbar color="primary">
  <div class="row">
    <a fsNavBack>
      <mat-icon class="back-icon">
        keyboard_arrow_left
      </mat-icon>
    </a>
    @if (account()) {
      <button
          mat-icon-button
          class="menu"
          (click)="sideNavClick()">
        <mat-icon>
          menu
        </mat-icon>
      </button>
    }
    <div
      fsNavComponent="image"
      type="image">
    </div>
    <div>
      <div fsNavSupertitle></div>
      <!-- Same slot the desktop navbar carries, so a control hung on the title
           does not disappear below the breakpoint that swaps them. -->
      <div class="fs-row.gap-sm">
        <div fsNavTitle></div>
        @if (titleTemplate(); as template) {
          <div class="fs-row title-slot">
            <ng-container [ngTemplateOutlet]="template"></ng-container>
          </div>
        }
      </div>
    </div>
  </div>
  <app-account-menu></app-account-menu>
</mat-toolbar>